"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import FeatureCell, { ProductFeatureValue } from "./FeatureCell";
import { Icon } from "@/components/formatters/MXPIcon";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
export type FeatureRowProps = {
  title: string;
  description?: string;
  productFeatureValues: ProductFeatureValue[];
};
const FeatureRow = t0 => {
  const $ = _c(19);
  const {
    feature,
    selectedIndexes
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const hasDescription = !!feature.description;
  let t1;
  if ($[0] !== feature.title || $[1] !== hasDescription || $[2] !== isOpen) {
    t1 = <div className="flex items-center gap-2 w-full max-w-[356px]">{hasDescription ? <button className="flex items-center gap-2 text-gray-m10 bg-transparent border-none text-left p-0 cursor-pointer" onClick={() => setIsOpen(_temp)} aria-expanded={isOpen}><span><Icon type="t2u-chevron-right" rotateDeg={isOpen ? "270" : "90"} size={12} label="Toggle Comparison Table Feature Cell" className="transition-transform duration-200 ease-in-out" /></span><h3 className="font-[Open_Sans,sans-serif] text-gray-m10 text-lg not-italic font-normal leading-8 tracking-[0.18px] !mb-0 max-sm:text-base max-sm:leading-[1.375rem]">{feature.title}</h3></button> : <h3 className="font-[Open_Sans,sans-serif] text-gray-m10 text-lg not-italic font-normal leading-8 tracking-[0.18px] !mb-0 max-sm:text-base max-sm:leading-[1.375rem]">{feature.title}</h3>}</div>;
    $[0] = feature.title;
    $[1] = hasDescription;
    $[2] = isOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== feature.description || $[5] !== hasDescription || $[6] !== isOpen) {
    t2 = hasDescription && isOpen && <CommonDescription description={feature.description} className="font-[Open_Sans,sans-serif] text-[#464b52] text-base not-italic font-normal leading-[1.375rem] tracking-[0.16px] bg-transparent border-none text-left pl-5 mt-2 [&_p]:!text-[#464b52] [&_p]:!text-base [&_p]:!leading-[1.375rem] [&_a]:!text-blue-trmb [&_a]:!underline t2-layout__description pt-2" />;
    $[4] = feature.description;
    $[5] = hasDescription;
    $[6] = isOpen;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <td className="px-6 py-4 text-left align-middle border-b border-gray-m2 w-[400px] font-medium">{t1}{t2}</td>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== feature.productFeatureValues || $[12] !== selectedIndexes) {
    let t5;
    if ($[14] !== feature.productFeatureValues) {
      t5 = (productIndex, index) => {
        const val = productIndex >= 0 ? feature.productFeatureValues[productIndex] : undefined;
        return val ? <FeatureCell key={`feature-cell-${index}`} value={val} /> : <td key={`feature-cell-${index}`} className="px-6 py-4 text-center align-middle border-b border-gray-m2"><div className="min-h-12" /></td>;
      };
      $[14] = feature.productFeatureValues;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = selectedIndexes.map(t5);
    $[11] = feature.productFeatureValues;
    $[12] = selectedIndexes;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <><tr>{t3}{t4}</tr></>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default FeatureRow;
function _temp(prev) {
  return !prev;
}